import React, { useState } from 'react';
import './RequestForm.css';
function RequestForm() {
    // State for form fields
    const [fullName, setFullName] = useState('');
    const [number, setNumber] = useState('');
    const [portfolioValue, setPortfolioValue] = useState('');
    const [predict, setPredict] = useState('');

    // State for error messages
    const [errors, setErrors] = useState({
        fullName: '',
        number: '',
        portfolioValue: '',
        predict: ''
    });

    // Validation function
    const validate = () => {
        let valid = true;
        let newErrors = {};

        if (!fullName) {
            newErrors.fullName = 'نام ضروری است.';
            valid = false;
        }

        const phoneRegex = /^09\d{9}$/;
        if (!number || !phoneRegex.test(number)) {
            newErrors.number = 'شماره تماس معتبر و ضروری است.';
            valid = false;
        }

        if (!portfolioValue) {
            newErrors.portfolioValue = 'ارزش فعلی پرتفوی ضروری است.';
            valid = false;
        }

        if (!predict) {
            newErrors.predict = 'انتخاب یک گزینه ضروری است.';
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        // حذف پیام‌های قبلی در صورت وجود
        const existingMessage = document.querySelector('.form-message');
        if (existingMessage) {
            existingMessage.remove();
        }

        if (validate()) {
            const formData = {
                fullName,
                number,
                portfolioValue,
                predict
            };

            try {
                let lastRequestTime = null;

                const response = await fetch('/credit/store', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                });

                const form = document.getElementById('form');

                if (response.ok) {
                    const successMessage = document.createElement('div');

                    const text = await response.text();

                    if(text == '1') {
                        if (window.dataLayer) {
                            window.dataLayer.push({
                                'event': 'credit_form2'
                            });
                        }

                        successMessage.className = 'form-message success-message';
                        successMessage.textContent = 'همکاران ما به زودی با شما تماس خواهند گرفت';


                        function sendPostBack() {
                            const currentTime = Date.now();

                            if (lastRequestTime && (currentTime - lastRequestTime < 60000)) {
                                console.warn('PostBack request blocked: Too many requests within 1 minute');
                                return;
                            }

                            lastRequestTime = currentTime;

                            const actionName = "register";
                            const urlParams = new URLSearchParams(window.location.search);
                            const iid = urlParams.get('utm_ma');
                            if (iid) {
                                const xhr = new XMLHttpRequest();
                                xhr.withCredentials = true;
                                xhr.open("GET", "https://api.mediaad.org/v1/events/post-back-new?actionName=" +
                                    actionName + "&clickId=" + iid, false);
                                xhr.send();
                            }
                        }

                        // Call the sendPostBack function
                        sendPostBack();

                    }else if(text == '3'){
                        successMessage.className = 'form-message error-message';
                        successMessage.textContent = 'شماره شما از قبل در سیستم ثبت شده است';
                    }

                    form.appendChild(successMessage);

                } else {
                    const errorMessage = document.getElementById('er');
                    errorMessage.textContent = 'خطایی در ارسال فرم رخ داده است.';
                    errorMessage.classList.add('form-message', 'error-message');
                }

            } catch (error) {
                const errorMessage = document.getElementById('er');
                errorMessage.textContent = 'مشکلی در ارتباط با سرور وجود دارد.';
                errorMessage.classList.add('form-message', 'error-message');
            }
        }
    };



    return (
        <div className="form iransans">

            <div id="er">
                <div>
                    <div>
                        <h2>فرم درخواست اعتبار</h2>
                    </div>

                    <form id="form" onSubmit={handleSubmit}>
                        <div className="grid-x grid-padding-x">
                            <div className="small-12 medium-6 cell margin-1 padding-1">
                                <input name="fullName" id="fullName" type="text" value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="نام و نام خانوادگی"/>
                                {errors.fullName && <span className="error">{errors.fullName}</span>}
                            </div>
                            <div className="small-12 medium-6 cell margin-1 padding-1">
                                <input name="number" id="number" type="text" value={number} onChange={(e) => setNumber(e.target.value)} placeholder="شماره تماس" autoComplete="tel"/>
                                {errors.number && <span className="error">{errors.number}</span>}
                            </div>
                        </div>

                        <select className="margin-1" id="PortfolioValue" name="PortfolioValue" value={portfolioValue} onChange={(e) => setPortfolioValue(e.target.value)}>
                            <option value="" disabled>ارزش فعلی پرتفوی</option>
                            <option value="تا 500 میلیون تومان">تا 500 میلیون تومان</option>
                            <option value="از 500 میلیون تا یک میلیارد تومان">از 500 میلیون تا یک میلیارد تومان</option>
                            <option value="بیش از یک میلیارد تومان">بیش از یک میلیارد تومان</option>
                        </select>
                        {errors.portfolioValue && <span className="error">{errors.portfolioValue}</span>}

                        <fieldset className="margin-1">
                            <legend>
                                از آخرین معامله‌ای که در بورس داشتید، چه مدت گذشته است؟
                                <span> (ضروری) </span>
                            </legend>

                            <div>
                                <input id="moreThanThreeMonths" name="predict" type="radio" checked={predict === "بیشتر از سه ماه"} value="بیشتر از سه ماه" onChange={(e) => setPredict(e.target.value)}/>
                                <label htmlFor="moreThanThreeMonths">بیشتر از سه ماه</label>
                            </div>

                            <div>
                                <input id="oneToThreeMonths" name="predict" type="radio" checked={predict === "یک تا سه ماه"} value="یک تا سه ماه" onChange={(e) => setPredict(e.target.value)}/>
                                <label htmlFor="oneToThreeMonths">یک تا سه ماه</label>
                            </div>

                            <div>
                                <input id="lessThanOneMonth" name="predict" type="radio" checked={predict === "کمتر از یک ماه"} value="کمتر از یک ماه" onChange={(e) => setPredict(e.target.value)}/>
                                <label htmlFor="lessThanOneMonth">کمتر از یک ماه</label>
                            </div>

                            {errors.predict && <span className="error">{errors.predict}</span>}
                        </fieldset>
                        <button type="submit" className="button">درخواست دریافت اعتبار</button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default RequestForm;